import { render } from "./soldierOrderQrCode.vue?vue&type=template&id=ca96df6e"
import script from "./soldierOrderQrCode.vue?vue&type=script&lang=js"
export * from "./soldierOrderQrCode.vue?vue&type=script&lang=js"

import "./soldierOrderQrCode.vue?vue&type=style&index=0&id=ca96df6e&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__